<!-- mobile app  -->
<div class="app-login p-2" id="getapp_link" *ngIf="show_app_strip==true && content_condition!=1">
  <div class="container">
    <table cellpadding="0" border="0" cellspacing="0" width="100%">
      <tr>
        <td width="5%"><button class="text-white"
            style="cursor:pointer; color:#fff !important; background-color: transparent; border: none; padding: 0;"
            (click)="hide_app_strip()">
            <svg id="Layer_1" data-name="Layer 1" width="15px" class="mr-2" viewBox="0 0 12 12">
              <defs>
                <style>
                  .cls-1 {
                    fill: none;
                    stroke: #fff;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  }
                </style>
              </defs>
              <line class="cls-1" x1="1" y1="1.04" x2="11" y2="10.96" />
              <line class="cls-1" x1="1" y1="10.96" x2="11" y2="1.04" />
            </svg>
          </button></td>
        <td>
          <p style="margin:0px; font-size: 12px;" class="text-white clearfix"><img class="float-left"
              style="border-radius:10%;background-color: #fff;margin-right:10px;padding: 12px 7px;" width="45px"
              src="assets/img/icon-docquity.png" /> <span class="float-left"><b>
                {{mls?.languageText?.common?.key1}}<span *ngIf="mls?.is_lskey_display==1">(common.key1)</span></b>
              <br /><b> {{mls?.languageText?.common?.key2}}<span
                  *ngIf="mls?.is_lskey_display==1">(common.key2)</span></b>
            </span></p>
        </td>
        <td class="footer-remove-href" (click)="gotoSectionById('What-Doctors-Do','expert_lectures')"
          class="text-right">
          <button
            [eventTracker]='{"category":"web_share","action":"install_app_click","product_type":"","product_id":""}'
            class="bg-white btn text-success btn-default" style="font-size: 12px;" (click)="installApp()">
            {{mls?.languageText?.common?.key3}}<span *ngIf="mls?.is_lskey_display==1">(common.key3)</span></button></td>
      </tr>
    </table>
  </div>
</div>
<!-- end mobile app -->

<div class="header bg-white">
  <div class="container pt-2 text-center pb-2">

    <img class="cursor-pointer" (click)="getApiService.navigateToHome()" src="assets/img/logo_dark.svg" width="145px" />

    <div class="dropdown mt-2 text-right">
      <button class="btn btn-default border fnt-size14px dropdown-toggle" type="button" id="dropdownMenuButton"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Change Language
      </button>
      <div class="dropdown-menu fnt-size14px" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="javascript:void()" (click)="selectLang('en')">ENGLISH</a>
        <a class="dropdown-item" href="javascript:void()" (click)="selectLang('vi')">VIETNAMESE</a>
        <a class="dropdown-item" href="javascript:void()" (click)="selectLang('zh')">MANDARIN</a>
      </div>
    </div>
    <!-- <li><a (click)="selectLang('en')">en</a></li>
    <li><a (click)="selectLang('vi')">vi</a></li> -->
  </div>
</div>
<div class="mt-2" [ngClass]="{'container': productType != '36', 'container-doctalk-series': productType == '36' }">
  <app-clinical *ngIf="productType==3" [content_condition]="content_condition" [referal_id]="referID"
    [product_type]="productType" [product_type_id]="productID"></app-clinical>

  <app-event *ngIf="productType==7" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID" [eventType]="eventProductType">
  </app-event>

  <app-cme *ngIf="productType==8" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID">
  </app-cme>

  <app-channel *ngIf="productType==10" [referal_id]="referID" [product_type]="productType"
    [product_type_id]="productID"></app-channel>

  <app-doctalk *ngIf="productType==24" [referal_id]="referID" [product_type]="productType"
    [product_type_id]="productID"></app-doctalk>

  <app-session *ngIf="productType==21" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID"
    [parent_product]="parent_product" [sessionType]="eventProductType"></app-session>

  <app-survey *ngIf="productType==25" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID">
  </app-survey>

  <app-webinar *ngIf="productType==27" [referal_id]="referID" [product_type]="productType"
    [product_type_id]="productID"></app-webinar>

  <app-pharma *ngIf="productType==28" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID">
  </app-pharma>

  <app-feed *ngIf="productType==1" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID">
  </app-feed>

  <app-profile *ngIf="productType==14" [referal_id]="referID" [product_type]="productType"
    [product_type_id]="productID"></app-profile>

  <app-drug *ngIf="productType==15" [referal_id]="referID" [product_type]="productType" [product_type_id]="productID">
  </app-drug>

  <app-doctalk-series *ngIf="productType==36" [referalId]="referID" [productType]="productType" [productTypeId]="productID">
  </app-doctalk-series>

  <app-meeting *ngIf="productType==41" [referralId]="referID" [productType]="productType" [productTypeId]="productID">
  </app-meeting>

  <!-- <app-profile></app-profile> -->
</div>
